<template>
  <div>
    <vt-date-picker
      ref="datePicker"
      lang="es"
      :model="model"
      :not-after="notAfter"
      @update="model = $event"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'DatePickerRenderer',
    props: {
        options: { type: Object, default: () => {} }
    },
    data() {
        return {
            model: null,
            notAfter: false
        }
    },
    computed: {

    },
    mounted() {
        this.model = this.params.value
        this.notAfter = this.params.notAfter
        this.$nextTick(() => {
            this.$refs.datePicker.focus()
        })
    },
    methods: {
        getValue() {
            if (this.model) {
                return this.model
            }
            return this.params.value
        }

    }

})

</script>
